<template>
  <div>
    <v-alert prominent type="warning" v-if="activeWS === null">
      <v-row align="center">
        <v-col class="grow">No work session started.</v-col>
        <v-col class="shrink">
          <router-link :to="{name: 'worksession.create'}">
            <v-btn icon>
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </router-link>
        </v-col>
      </v-row>
    </v-alert>

    <v-card v-if="activeWS != null" :loading="deleteLoading">
      <v-toolbar dark>
        <v-toolbar-title>Active work site</v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn icon @click="doDeleteWorksession" :loading="deleteLoading">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-list two-line>
        <v-list-item-group multiple active-class="black--text">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title v-text="activeWS.site.name" />
            </v-list-item-content>

            <v-list-item-action>
              <v-list-item-action-text v-text="activeWS.hoursSpent + ' hrs.'"></v-list-item-action-text>
              <v-icon>
                mdi-clock
              </v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list-item-group>
      </v-list>

      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn text color="green" @click="showEditHours = !showEditHours">Edit hours</v-btn>
        <v-btn text color="red" @click="doEndWorksession">End</v-btn>
      </v-card-actions>

      <v-expand-transition>
        <div v-show="showEditHours">
          <v-card-text>
            <HoursInput v-model="hours" label="Adjust manager's hours" :value="activeWS.hoursSpent" />
            <div class="mt-3">
              <div class="flex-shrink-1"></div>
              <v-btn block color="green" outlined :loading="updateHoursLoading" @click="doUpdateManagerHours"><v-icon left>mdi-update</v-icon>Update</v-btn>
            </div>
          </v-card-text>
        </div>
      </v-expand-transition>

    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import HoursInput from "./HoursInput"

export default {
  components: {
    HoursInput
  },
  data () {
    return {
      deleteLoading: false,
      showEditHours: false,
      updateHoursLoading: false,
      hours: 0
    }
  },
  methods: {
    ...mapActions(['deleteWorksession', 'endWorksession', 'updateManagerHours']),
    doDeleteWorksession () {
      this.$swal({
        title: 'Are you sure?',
        text: 'This session will be removed completely and it will be impossible to recover!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#b20101'
      }).then((result) => {
        if (result.value) {
          this.deleteLoading = true
          this.deleteWorksession(this.activeWS.workSessionId)
        }
      })
    },
    doEndWorksession () {
      this.$swal({
        title: 'Are you sure?',
        text: 'This session will be ended and saved. You will be able to create a new one, and to reuse the workers from this one. Continue?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'End',
        confirmButtonColor: '#b20101'
      }).then((result) => {
        if (result.value) {
          this.deleteLoading = true
          this.endWorksession(this.activeWS.workSessionId)
        }
      })
    },
    doUpdateManagerHours () {
      const data = {
        worksessionId: this.activeWS.workSessionId,
        spentHours: this.hours
      }
      this.updateHoursLoading = true
      this.updateManagerHours(data)
        .then(resp => {
          this.showEditHours = this.updateHoursLoading = false
        })
    }
  },
  computed: {
    ...mapGetters(['activeWS'])
  },
  created () {
      this.hours = this.activeWS ? this.activeWS.hoursSpent : 0
  }
}
</script>

<style>

</style>
